function CarServiceIcon({ width = '21', height = '20', fill = '#615A5A' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_10938_197528"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect x="0.499512" width="19.7054" height="19.7054" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_10938_197528)">
        <mask
          id="mask1_10938_197528"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="15"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.48498 0.271293C5.37075 0.465073 4.89921 0.954525 4.26426 1.98031C3.4717 3.25926 2.71983 4.62197 2.09715 5.73965C1.54229 6.73481 1.30588 7.62432 1.30588 8.71449C1.30588 9.74403 1.645 10.601 2.1133 11.6962V13.4227C2.1133 13.8534 2.47502 14.2041 2.92072 14.2041H4.13184C4.57754 14.2041 4.93926 13.8534 4.93926 13.4227V12.6414H15.4357V13.4227C15.4357 13.8534 15.7974 14.2041 16.2431 14.2041H17.4542C17.8999 14.2041 18.2617 13.8534 18.2617 13.4227V11.6962C18.73 10.5998 19.0691 9.74403 19.0691 8.71449C19.0691 7.62432 18.8327 6.73481 18.2778 5.73965C17.6629 4.63573 16.9058 3.26301 16.1107 1.98031C15.4757 0.954525 15.0049 0.465698 13.8893 0.271293C12.7628 0.0756369 11.7248 0 10.1875 0C8.65016 0 7.61149 0.0756369 6.48498 0.271293ZM4.69275 4.39477C5.00151 3.85781 5.32254 3.31085 5.64938 2.78327C6.19003 1.91126 6.3373 1.88625 6.77137 1.80936C7.79582 1.63309 8.75374 1.56308 10.1877 1.56308C11.6217 1.56308 12.5803 1.63246 13.6041 1.80936C14.0381 1.88625 14.1854 1.91126 14.7261 2.78327C15.0555 3.31523 15.3804 3.86781 15.6911 4.40977C14.5155 4.58167 12.4453 4.82796 10.1877 4.82796C7.7267 4.82796 5.73335 4.5648 4.69275 4.39477ZM2.9211 8.71494C2.9211 7.43224 3.32933 6.82277 3.87708 5.84074C4.71744 6.00014 7.08027 6.39082 10.1879 6.39082C12.999 6.39082 15.4852 6.03514 16.5129 5.86574C17.0496 6.82714 17.4546 7.43536 17.4546 8.71494C17.4546 10.0214 16.3604 11.0791 15.0111 11.0791H5.36402C4.01531 11.0791 2.9211 10.0214 2.9211 8.71494ZM17.6971 3.26458L18.5736 4.82795C19.131 4.82795 19.8784 4.6748 19.8784 4.0547V3.65589C19.8784 3.44023 19.6975 3.26458 19.4747 3.26458H17.6971ZM0.903221 3.26451C0.681019 3.26451 0.499512 3.44016 0.499512 3.65582V4.05464C0.499512 4.67473 1.24686 4.82788 1.8043 4.82788L2.68148 3.26451H0.903221ZM14.2264 8.34355C14.2264 8.99053 14.7683 9.51499 15.4375 9.51499C16.1061 9.51499 16.6486 8.99053 16.6486 8.34355C16.6486 7.69658 16.1061 7.17149 15.4375 7.17149C14.7683 7.17149 14.2264 7.69658 14.2264 8.34355ZM3.72933 8.34355C3.72933 8.99053 4.27191 9.51499 4.94046 9.51499C5.609 9.51499 6.15158 8.99053 6.15158 8.34355C6.15158 7.69658 5.609 7.17149 4.94046 7.17149C4.27191 7.17149 3.72933 7.69658 3.72933 8.34355ZM7.3641 8.73441C7.1419 8.73441 6.96039 8.90944 6.96039 9.1251C6.96039 9.34013 7.1419 9.51516 7.3641 9.51516H13.016C13.2389 9.51516 13.4197 9.34013 13.4197 9.1251C13.4197 8.90944 13.2389 8.73441 13.016 8.73441H7.3641Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_10938_197528)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-2.73022 17.3291H23.1072V-3.12598H-2.73022V17.3291Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-2.73022 19.5337H23.1072V-5.47021H-2.73022V19.5337Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
}

export default CarServiceIcon;
